module.exports = "/lucky-balls/img/jackpot/013.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/jackpot/013.png
// module id = 1113
// module chunks = 0